// 八卦吃瓜 · 站点数据源（仅用于前端展示，不涉及任何真实明星私事的事实性表述）
// 所有造型点评均为小编个人观点，示例内容不构成对任何真实人物的负面描述。

export interface CategoryItem {
  id: string;
  name: string;
  slogan: string;
  icon: string;
}

export interface GossipCard {
  id: string;
  cat: string;
  title: string;
  brief: string;
  punch: string;
  img: string;
  edition: string;
  reads: number;
  comments: number;
  tags: string[];
}

export interface FaqItem {
  q: string;
  a: string;
}

export const siteName = '八卦吃瓜';
export const siteSlogan = '红毯最前线 · 时尚最敢说';
export const siteIntro = '小编专注把红毯和活动现场的造型“瓜”一个个切开：版型、配色、妆容、动作管理，哪里翻车讲哪里，帮你把每次出场的看点一次看够。';

export const categories: CategoryItem[] = [
  { id: 'hongtan', name: '红毯翻车', slogan: '名场面集锦，走路也要稳', icon: 'ri-fire-line' },
  { id: 'zaoxing', name: '造型雷人', slogan: '大胆选择，有争议才有讨论', icon: 'ri-star-line' },
  { id: 'chuanda', name: '穿搭翻车', slogan: '单品没错，组合才是关键', icon: 'ri-price-tag-3-line' },
  { id: 'zhuangshan', name: '撞衫对比', slogan: '同款不同命，细节见高下', icon: 'ri-arrow-left-right-line' },
  { id: 'zhuangrong', name: '妆容失败', slogan: '底妆、眼妆、唇色逐帧看', icon: 'ri-palette-line' },
  { id: 'shishang', name: '时尚灾难', slogan: '劝退现场，收藏避雷', icon: 'ri-error-warning-line' },
];

export const categoryMap = Object.fromEntries(categories.map((c) => [c.id, c]));

export const allPosts: GossipCard[] = [
  {
    id: 'p01',
    cat: 'hongtan',
    title: '拖尾过长的代价：某女星红毯险些踩裙绊倒，全靠表情管理硬撑',
    brief: '超长拖尾是红毯礼服的气场来源，可裙摆一旦比台阶还“贪心”，转身和行走都会变成高危动作。本场最惊险一瞬，就在主持人伸手扶起的前两秒。',
    punch: '拖尾是铠甲也是陷阱，走路不低头，转身先甩裙，是每个穿超长裙的必修课。硬撑过关值得夸，但下次还是量好台阶再登场吧。',
    img: 'https://readdy.ai/api/search-image?query=long%20train%20evening%20gown%20woman%20tripping%20on%20red%20carpet%20steps%20paparazzi%20flash%20editorial%20photo%20dramatic%20warm%20crimson%20lighting%20gossip%20magazine%20style%20elegant%20but%20awkward%20moment%20blurred%20background&width=760&height=500&seq=red-01&orientation=landscape',
    edition: '第 28 期',
    reads: 128600,
    comments: 486,
    tags: ['红毯翻车', '礼服拖尾', '动作管理'],
  },
  {
    id: 'p02',
    cat: 'hongtan',
    title: '上下台阶哪一瞬最易翻车？小编逐帧拆解红毯“危险动作”',
    brief: '裙摆、高跟鞋、灯光和站位，红毯其实处处是机关。我们把最经典的几个“惊险瞬间”拆出来，聊聊明星们是如何在镜头前稳住阵脚的。',
    punch: '你以为明星走的是红毯，其实走的是体操。重心、裙摆和摄影师机位，任何一个没对上，下一秒就是年度盘点素材。',
    img: 'https://readdy.ai/api/search-image?query=woman%20in%20flowing%20evening%20dress%20walking%20down%20grand%20staircase%20red%20carpet%20high%20heels%20editorial%20fashion%20photography%20motion%20warm%20rose%20lighting%20magazine%20spread%20cinematic%20elegance&width=760&height=500&seq=red-02&orientation=landscape',
    edition: '第 28 期',
    reads: 98600,
    comments: 312,
    tags: ['红毯翻车', '台阶', '镜头拆解'],
  },
  {
    id: 'p03',
    cat: 'hongtan',
    title: '裙摆被鼓风机“掀桌”，谁的防走光功课又白做了？',
    brief: '红毯常有风，转身皆是戏。一场大风把某套轻薄礼服吹成“孔雀开屏”，周围尖叫与快门齐飞，明星本人反应成了全场最大看点。',
    punch: '轻薄面料选得好是仙气，选不好就是灾难预告片。防走光这件事，永远别在风大的夜里赌运气。',
    img: 'https://readdy.ai/api/search-image?query=evening%20dress%20skirt%20blowing%20upward%20in%20wind%20red%20carpet%20stylized%20editorial%20illustration%20fashion%20disaster%20motion%20blur%20warm%20vintage%20toned%20paper%20background%20gossip%20magazine%20vibe&width=760&height=500&seq=red-03&orientation=landscape',
    edition: '第 26 期',
    reads: 142300,
    comments: 529,
    tags: ['红毯翻车', '裙摆', '防走光'],
  },
  {
    id: 'q01',
    cat: 'zaoxing',
    title: '垫肩开到天际的西装，是气场拉满还是“真人变形金刚”？',
    brief: '超大垫肩带着复古力量感卷土重来，可一旦肩宽超过头围太多，观感就从“大女主”滑向“可变形”。到底要多大的垫肩才算恰到好处？',
    punch: '垫肩是给肩膀加戏，不是给观众加负担。廓形可以有，但别让衣领比人还宽。',
    img: 'https://readdy.ai/api/search-image?query=oversized%20padded%20shoulder%20blazer%20fashion%20editorial%20studio%20dramatic%20pose%20stylized%20vintage%20magazine%20cover%20crimson%20and%20gold%20accent%20contrast%20statement%20suit%20lighting&width=760&height=500&seq=style-01&orientation=landscape',
    edition: '第 27 期',
    reads: 87500,
    comments: 264,
    tags: ['造型雷人', '垫肩', '廓形'],
  },
  {
    id: 'q02',
    cat: 'zaoxing',
    title: '“水桶裙”反向出圈：这届造型师是不是对腰线有什么误会？',
    brief: '明明有修长的身材，却被一条无腰线的直筒长裙穿成了“行走的水桶”。腰线一没，气场全无，本期就聊怎么把高定穿出身材。',
    punch: '高定不等于合身，但连腰都找不到的衣服，建议直接退回衣帽间。造型可以大胆，身材比例也得留一条活路。',
    img: 'https://readdy.ai/api/search-image?query=straight%20column%20shapeless%20dress%20on%20runway%20fashion%20editorial%20backstage%20stylized%20warm%20beige%20cream%20backdrop%20avant%20garde%20couture%20dramatic%20pose%20magazine%20photography%20gossip%20style&width=760&height=500&seq=style-02&orientation=landscape',
    edition: '第 27 期',
    reads: 76200,
    comments: 218,
    tags: ['造型雷人', '腰线', '直筒裙'],
  },
  {
    id: 'q03',
    cat: 'zaoxing',
    title: '斗篷披肩+拖尾同框，是把红毯走成了“登基大典”',
    brief: '本场压轴造型把斗篷、披肩和超长拖尾全数堆上身，庄重有余、轻盈不足，仿佛下一秒就要宣读诏书。气势满分，但需要足够的空间才走得动。',
    punch: '造型想当“女皇”没问题，但得先确认场地不是机舱过道。元素堆叠是双刃剑，克制才是高级感的前提。',
    img: 'https://readdy.ai/api/search-image?query=royal%20cape%20coat%20with%20cape%20and%20long%20train%20red%20carpet%20queen%20like%20presence%20editorial%20fashion%20photography%20dramatic%20theatrical%20warm%20amber%20lighting%20cinematic%20vintage%20style&width=760&height=500&seq=style-03&orientation=landscape',
    edition: '第 25 期',
    reads: 110800,
    comments: 401,
    tags: ['造型雷人', '斗篷', '拖尾'],
  },
  {
    id: 'c01',
    cat: 'chuanda',
    title: '脖子上的“三层项链塔”，是把珠宝戴成刑具的反面教材',
    brief: '叠戴是本季流行，可一旦项链堆到下巴都抬不起来，就成了造型翻车现场。珠宝是锦上添花，不是雪上加霜。',
    punch: '叠戴的精髓是层次不是厚度。能露锁骨的地方就别急着塞满配饰，留白才是高级。',
    img: 'https://readdy.ai/api/search-image?query=woman%20wearing%20too%20many%20layered%20statement%20necklaces%20necklace%20stack%20fashion%20editorial%20close%20up%20warm%20gold%20jewelry%20stylized%20magazine%20photography%20crimson%20backdrop%20accessory%20overload&width=760&height=500&seq=wear-01&orientation=landscape',
    edition: '第 26 期',
    reads: 83400,
    comments: 256,
    tags: ['穿搭翻车', '叠戴', '配饰'],
  },
  {
    id: 'c02',
    cat: 'chuanda',
    title: '艳色高饱和撞亮色鞋，红毯也能一秒变“芭比闹剧”',
    brief: '颜色本身没有错，错在把饱和度最高的两件单品放在同一套身上互搏。本期用同一位嘉宾的两套配色对比，讲清楚什么才是“吸睛而非刺眼”。',
    punch: '撞色讲的是平衡，不是把调色盘直接倒上身。想亮眼，先学会让一件单品安静下来。',
    img: 'https://readdy.ai/api/search-image?query=colorful%20clashing%20outfit%20bright%20magenta%20dress%20with%20vivid%20orange%20shoes%20fashion%20editorial%20stylized%20studio%20backdrop%20high%20saturation%20loud%20color%20combinations%20magazine%20editorial%20vibrant&width=760&height=500&seq=wear-02&orientation=landscape',
    edition: '第 24 期',
    reads: 96800,
    comments: 340,
    tags: ['穿搭翻车', '撞色', '高饱和'],
  },
  {
    id: 'c03',
    cat: 'chuanda',
    title: '透视纱裙×亮片内搭，从“仙”到“土”只差一层纱',
    brief: '轻薄纱裙原本仙气飘飘，可当它遇上过于实穿的打底与亮片，整体质感立刻断崖式下跌。面料质感与内搭选择的学问，本期一次讲清。',
    punch: '纱裙的仙气来自“若隐若现”的克制。内搭一旦过于抢戏，仙气就变成了俗气。',
    img: 'https://readdy.ai/api/search-image?query=sheer%20tulle%20dress%20layered%20over%20sequin%20slip%20fashion%20editorial%20soft%20pink%20studio%20stylized%20magazine%20photography%20texture%20focus%20warm%20neutral%20backdrop%20elegance%20vs%20kitsch&width=760&height=500&seq=wear-03&orientation=landscape',
    edition: '第 23 期',
    reads: 71500,
    comments: 189,
    tags: ['穿搭翻车', '纱裙', '透视'],
  },
  {
    id: 'z01',
    cat: 'zhuangshan',
    title: '同款战袍隔空撞衫，一个赢了气场一个输在细节',
    brief: '同一件大胆设计的礼服，在不同身姿与妆容的演绎下高下立现。我们把两套同款拼在一起，从肩线、发色到鞋履逐项打分。',
    punch: '撞衫不可怕，谁输谁尴尬。但输的从来不是身材，而是发型妆容与配饰是否跟得上衣服的野心。',
    img: 'https://readdy.ai/api/search-image?query=two%20fashionable%20women%20wearing%20the%20same%20red%20gown%20split%20screen%20comparison%20red%20carpet%20celebrity%20same%20dress%20face%20off%20editorial%20photo%20stylized%20warm%20lighting%20magazine%20meme%20style%20contrast&width=760&height=500&seq=clash-01&orientation=landscape',
    edition: '第 28 期',
    reads: 158400,
    comments: 612,
    tags: ['撞衫对比', '同款', '气场'],
  },
  {
    id: 'z02',
    cat: 'zhuangshan',
    title: '黑白经典同款西装撞车：谁把高定穿出了“职场天花板”？',
    brief: '经典黑白西装看似谁都能驾驭，其实最考验版型与比例。同款不同人的演绎里，气场差距肉眼可见。',
    punch: '基础款是最诚实的衣服，它把每个人的身材功课都照得清清楚楚。别怪西装普通，先问自己腰线有没有立起来。',
    img: 'https://readdy.ai/api/search-image?query=two%20women%20in%20matching%20black%20white%20tailored%20blazer%20suits%20standing%20side%20by%20side%20comparison%20fashion%20editorial%20clean%20studio%20warm%20neutral%20grey%20backdrop%20power%20dressing%20contrast%20magazine%20layout&width=760&height=500&seq=clash-02&orientation=landscape',
    edition: '第 27 期',
    reads: 120900,
    comments: 487,
    tags: ['撞衫对比', '西装', '职场'],
  },
  {
    id: 'z03',
    cat: 'zhuangshan',
    title: '小礼裙大撞车，同款翻红里谁穿出了“本命”感？',
    brief: '当一件高腰小礼裙短时间内被多次穿出，撞衫合集就成了检验“谁最懂这件衣服”的现场。来看小编给这组同款打的分数。',
    punch: '同一件衣服没有标准答案，但一定有更聪明的打开方式。本命感，说到底是你和衣服的化学反应。',
    img: 'https://readdy.ai/api/search-image?query=three%20women%20wearing%20the%20same%20pastel%20mini%20cocktail%20dress%20different%20styling%20comparison%20fashion%20editorial%20soft%20warm%20studio%20lighting%20stylized%20magazine%20spread%20duplicate%20outfit%20showdown&width=760&height=500&seq=clash-03&orientation=landscape',
    edition: '第 22 期',
    reads: 89300,
    comments: 275,
    tags: ['撞衫对比', '小礼裙', '同款'],
  },
  {
    id: 'm01',
    cat: 'zhuangrong',
    title: '“假白脸”翻车实录：粉底色号选错，赢了灯光输了照片',
    brief: '灯光下看着完美的底妆，出了摄影棚就发灰发白。本期聊聊为什么选对色号比选贵粉底更重要，以及怎么判断“白了还是假了”。',
    punch: '底妆的最高境界是像自己的第二层皮肤。色号跑偏，再贵的粉底也是白费，还会顺手拖累整套造型。',
    img: 'https://readdy.ai/api/search-image?query=makeup%20foundation%20shade%20mismatch%20pale%20ghostly%20face%20editorial%20beauty%20photography%20makeup%20fail%20close%20up%20beauty%20products%20warm%20lighting%20stylized%20magazine%20beauty%20feature&width=760&height=500&seq=make-01&orientation=landscape',
    edition: '第 26 期',
    reads: 103500,
    comments: 376,
    tags: ['妆容失败', '底妆', '色号'],
  },
  {
    id: 'm02',
    cat: 'zhuangrong',
    title: '上挑眼线“过山车”，一个眼神从媚到凶只差一度',
    brief: '眼线是妆容里的点睛笔，可上扬角度一旦失控，温柔眼神秒变凌厉“过山车”。本期从眼型出发聊聊最适合的线条角度。',
    punch: '眼线不是越高越精神，而是越贴合眼型越有神。角度差一度，情绪就能从“撩”滑向“凶”。',
    img: 'https://readdy.ai/api/search-image?query=eyeliner%20wing%20too%20sharp%20dramatic%20cat%20eye%20makeup%20editorial%20beauty%20close%20up%20makeup%20mistake%20stylized%20warm%20studio%20magazine%20beauty%20editorial%20contrast%20glamour&width=760&height=500&seq=make-02&orientation=landscape',
    edition: '第 24 期',
    reads: 78800,
    comments: 233,
    tags: ['妆容失败', '眼线', '眼型'],
  },
  {
    id: 'm03',
    cat: 'zhuangrong',
    title: '死亡芭比粉口红，是被肤色耽误还是被发型连累？',
    brief: '同一支亮粉色唇膏，在不同肤色与打光下效果天差地别。本期实测三种肤色与三种唇妆的搭配，帮你避开“显黑重灾区”。',
    punch: '没有绝对丑的颜色，只有没找对场合和肤色的涂法。芭比粉也能好看，关键看你怎么搭。',
    img: 'https://readdy.ai/api/search-image?query=hot%20barbie%20pink%20lipstick%20swatch%20beauty%20editorial%20lipstick%20fail%20makeup%20close%20up%20glossy%20lips%20stylized%20warm%20pink%20studio%20backdrop%20magazine%20beauty%20feature%20vivid%20colors&width=760&height=500&seq=make-03&orientation=landscape',
    edition: '第 23 期',
    reads: 92100,
    comments: 298,
    tags: ['妆容失败', '口红', '肤色'],
  },
  {
    id: 's01',
    cat: 'shishang',
    title: '“彩虹全身披挂”出街：时尚灾难还是行为艺术？',
    brief: '当整条彩虹被同时穿在身上，镜头前确实没有死角，但也几乎找不到重点。本期把这类“用力过猛”的造型单独拎出来当反面教材。',
    punch: '时尚是让你发光，不是让衣服发光把你淹没。想要回头率，先学会给造型留一个视觉焦点。',
    img: 'https://readdy.ai/api/search-image?query=rainbow%20colors%20all%20over%20outfit%20clashing%20patterns%20fashion%20disaster%20editorial%20illustration%20loud%20busy%20print%20stylized%20vintage%20magazine%20poster%20warm%20toned%20paper%20texture%20satirical%20gossip%20style&width=760&height=500&seq=disaster-01&orientation=landscape',
    edition: '第 25 期',
    reads: 135700,
    comments: 544,
    tags: ['时尚灾难', '彩虹', '用力过猛'],
  },
  {
    id: 's02',
    cat: 'shishang',
    title: '一头“冲天辫”+全身荧光绿，红毯不是幼儿园运动会',
    brief: '当造型师决定把发饰、配色和夸张廓形全部堆到失控，红毯瞬间变成另类秀场。大胆可以，但请先和旁边人确认是红毯不是演唱会。',
    punch: '个性表达和哗众取宠之间，往往就差一个克制的边界。想让人记住，靠的是风格不是惊吓。',
    img: 'https://readdy.ai/api/search-image?query=neon%20green%20outfit%20with%20crazy%20towering%20hairstyle%20fashion%20disaster%20editorial%20stylized%20magazine%20photography%20avant%20garde%20gone%20wrong%20warm%20stage%20lighting%20satirical%20commentary&width=760&height=500&seq=disaster-02&orientation=landscape',
    edition: '第 21 期',
    reads: 121400,
    comments: 472,
    tags: ['时尚灾难', '荧光', '发型'],
  },
  {
    id: 's03',
    cat: 'shishang',
    title: '羽毛大氅空降红毯：走的是红毯还是《天鹅湖》片场？',
    brief: '一根根白色羽毛铺成整件大衣，确实足够抢镜，却也让人分不清是在颁奖典礼还是在舞台剧后台。羽毛元素，适量才优雅。',
    punch: '羽毛是氛围感神器，但一次性穿成“羽界天花板”，观众只会关心你到底掉不掉毛。',
    img: 'https://readdy.ai/api/search-image?query=giant%20feather%20coat%20dramatic%20swan%20lake%20look%20red%20carpet%20fashion%20editorial%20white%20feathers%20stylized%20theatrical%20warm%20spotlight%20magazine%20photography%20couture%20statement%20over%20the%20top&width=760&height=500&seq=disaster-03&orientation=landscape',
    edition: '第 20 期',
    reads: 98600,
    comments: 389,
    tags: ['时尚灾难', '羽毛', '戏剧化'],
  },
];

// 头条大卡（红毯翻车精选）
export const headline = allPosts.find((p) => p.id === 'p03')!;
export const featuredRight = [
  allPosts.find((p) => p.id === 'z01')!,
  allPosts.find((p) => p.id === 's01')!,
];

// 热门吃瓜榜（从盘点中挑出的高热度条目）
export interface RankItem {
  id: string;
  title: string;
  reads: number;
  heat: '爆' | '热' | '新';
}

export const hotList: RankItem[] = [
  { id: 'z01', title: '同款战袍隔空撞衫，一个赢了气场一个输在细节', reads: 158400, heat: '爆' },
  { id: 'p03', title: '裙摆被鼓风机“掀桌”，谁的防走光功课又白做了？', reads: 142300, heat: '爆' },
  { id: 's01', title: '“彩虹全身披挂”出街：时尚灾难还是行为艺术？', reads: 135700, heat: '热' },
  { id: 'p01', title: '拖尾过长的代价：某女星红毯险些踩裙绊倒', reads: 128600, heat: '热' },
  { id: 's02', title: '冲天辫+全身荧光绿，红毯不是幼儿园运动会', reads: 121400, heat: '热' },
  { id: 'z02', title: '黑白经典同款西装撞车：谁穿出了“职场天花板”？', reads: 120900, heat: '热' },
  { id: 'q03', title: '斗篷披肩+拖尾同框，把红毯走成了“登基大典”', reads: 110800, heat: '新' },
  { id: 'm01', title: '“假白脸”翻车实录：粉底色号选错，赢了灯光输了照片', reads: 103500, heat: '热' },
  { id: 'p02', title: '上下台阶哪一瞬最易翻车？逐帧拆解红毯“危险动作”', reads: 98600, heat: '新' },
  { id: 'c02', title: '艳色高饱和撞亮色鞋，红毯一秒变“芭比闹剧”', reads: 96800, heat: '新' },
];

export const faqs: FaqItem[] = [
  {
    q: '“吃瓜”为什么叫吃瓜？',
    a: '吃瓜源于中文网络语境，指围观公众事件并参与讨论的状态。八卦吃瓜把红毯和活动现场的造型话题比作一个个“瓜”，小编帮大家切开、分析、点评，让围观更有趣。',
  },
  {
    q: '撞衫对比是什么？',
    a: '撞衫指两位及以上嘉宾在相近时间穿了同款或高度相似的礼服与单品。我们会把同框造型放在一起对比版型、配色和驾驭效果，看谁把衣服穿出了高级感。',
  },
  {
    q: '造型雷人和穿搭翻车有区别吗？',
    a: '穿搭翻车偏指搭配比例、单品选择上出现了失误；造型雷人则更强调整体造型的反常与冲击力。两者都常出现在红毯与活动造型盘点中。',
  },
  {
    q: '点评会不会太主观？',
    a: '造型评价天然带有审美取向，我们会在开头说明判断依据，也欢迎你在评论区表达不同意见。时尚没有唯一标准，观点碰撞本身就是吃瓜的乐趣。',
  },
  {
    q: '内容多久更新一次？',
    a: '我们按“期”更新，紧跟近期红毯与大型活动现场，每次活动结束后 1-2 天内会推出对应盘点，重要场合会加开特别期。',
  },
  {
    q: '可以投稿爆料或纠正细节吗？',
    a: '欢迎通过页尾“找小编”渠道来信投稿活动造型或纠正事实细节，我们会在核对后于后续盘点中致谢并修正。',
  },
];

export function formatReads(n: number): string {
  if (n >= 10000) return `${(n / 10000).toFixed(1)}w`;
  return `${n}`;
}